import { render, staticRenderFns } from "./ResetPasswordSubmitPage.vue?vue&type=template&id=f47a8750&scoped=true"
import script from "./ResetPasswordSubmitPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordSubmitPage.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordSubmitPage.vue?vue&type=style&index=0&id=f47a8750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47a8750",
  null
  
)

export default component.exports